class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.stickyBar = this;
    this.mainSection = document.getElementById('pp-' + this.dataset.sectionId) || document.getElementById(this.dataset.sectionId);
    if (!this.mainSection) {
      console.warn('[StickyATC] Could not find main product section.');
      return;
    }
    this.purchaseSection = this.mainSection.querySelector('.pp-block-buy_buttons') || this.mainSection.querySelector('.pp-info-column') || this.mainSection;
    this.variantSelect = this.querySelector('.sticky-atc-variant-select');
    this.qtyInput = this.querySelector('.sticky-atc-qty');
    this.qtyMinusBtn = this.querySelector('.sticky-atc-qty-minus');
    this.qtyPlusBtn = this.querySelector('.sticky-atc-qty-plus');
    this.submitBtn = this.querySelector('.sticky-atc-btn');
    this.priceGroup = this.querySelector('.sticky-atc-prices .product-price');
    this.priceElement = this.querySelector('.sticky-atc-price') || this.querySelector('.product-price__current');
    this.compareAtPriceElement = this.querySelector('.product-price__compare');
    this.discountBadgeElement = this.querySelector('.product-price__badge');
    this.discountBadgeTextElement = this.querySelector('.product-price__badge-text');
    this.imageElement = this.querySelector('.sticky-atc-image');
    this.variantTextElement = this.querySelector('.sticky-atc-variant-text');

    this.init();
  }

  init() {
    this.setupScrollListener();

    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
    }

    if (this.variantSelect) {
      this.updateDetailsFromVariant(this.variantSelect.options[this.variantSelect.selectedIndex]);
    }

    if (this.qtyMinusBtn) {
      this.qtyMinusBtn.addEventListener('click', () => {
        let val = parseInt(this.qtyInput.value) || 1;
        if (val > 1) this.qtyInput.value = val - 1;
      });
    }

    if (this.qtyPlusBtn) {
      this.qtyPlusBtn.addEventListener('click', () => {
        let val = parseInt(this.qtyInput.value) || 1;
        this.qtyInput.value = val + 1;
      });
    }
  }

  setupScrollListener() {
    if (!this.purchaseSection) return;

    const checkVisibility = () => {
      const rect = this.purchaseSection.getBoundingClientRect();
      const isPastForm = rect.bottom < 0;

      if (isPastForm) {
        this.stickyBar.classList.add('is-visible');
      } else {
        this.stickyBar.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();
  }

  onVariantChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    this.updateDetailsFromVariant(selectedOption);

    const mainForm =
      this.mainSection.querySelector('.pp-block-buy_buttons form.pp-form') ||
      this.mainSection.querySelector('form.pp-form');

    if (mainForm) {
      const mainVariantInput = mainForm.querySelector('input[name="id"]');
      if (mainVariantInput) {
        mainVariantInput.value = selectedOption.value;
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const mainSelect = mainForm.querySelector('select[name="id"]');
      if (mainSelect) {
        mainSelect.value = selectedOption.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  updateDetailsFromVariant(option) {
    if (!option) return;

    if (this.priceElement && option.dataset.price) {
      this.priceElement.innerHTML = option.dataset.price;
    }

    const onSale = option.dataset.onSale === 'true';

    if (this.priceGroup) {
      this.priceGroup.classList.toggle('product-price--on-sale', onSale);
    }

    if (this.compareAtPriceElement) {
      if (onSale && option.dataset.compareAtPrice) {
        this.compareAtPriceElement.innerHTML = option.dataset.compareAtPrice;
        this.compareAtPriceElement.hidden = false;
      } else {
        this.compareAtPriceElement.innerHTML = '';
        this.compareAtPriceElement.hidden = true;
      }
    }

    if (this.discountBadgeElement) {
      if (onSale && option.dataset.discount) {
        if (this.discountBadgeTextElement) {
          this.discountBadgeTextElement.textContent = '-' + option.dataset.discount + '%';
        }
        this.discountBadgeElement.hidden = false;
      } else {
        this.discountBadgeElement.hidden = true;
      }
    }

    if (this.imageElement && option.dataset.image) {
      this.imageElement.src = option.dataset.image;
    }

    if (this.variantTextElement && option.dataset.title && option.dataset.title !== 'Default Title') {
      this.variantTextElement.innerHTML = option.dataset.title;
      this.variantTextElement.style.display = 'block';
    } else if (this.variantTextElement) {
      this.variantTextElement.style.display = 'none';
    }

    if (this.submitBtn) {
      if (option.dataset.available === 'true') {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'ADD TO CART';
      } else {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'SOLD OUT';
      }
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
